import { GET_REVIEW } from '../actions/Types'

const getReview = (state=[], action) => {
    if (action.type === GET_REVIEW){
        return action.payload
    }
    return state
}

export default getReview